import React from "react";
import { useHistory } from "react-router-dom";

import InputPhone from "../../../Components/InputPhone";
import { SignInError } from "../../../Theme";
import { Form, InputGroup, Title, Step } from "../style";

const DDI_BRASIL = "55";

export default function StepOne() {
  const history = useHistory();
  const [isErrorPhoneFormat, setIsErrorPhoneFormat] = React.useState(false);

  function handleSubmit(event) {
    event.preventDefault();

    const whatsapp = event.target.whatsapp.value.replace(/\D/g, "");

    if (!/(\d{2})(\d{4,5})(\d{4})/.test(whatsapp)) {
      setIsErrorPhoneFormat(true);
      return;
    }

    if (window.fbq) {
      window.fbq("track", "StepTwoRegistration");
    }

    const data = {
      ...JSON.parse(localStorage.getItem("signInData")),
      businessName: event.target.business_name.value,
      city: event.target.city.value,
      whatsapp: DDI_BRASIL + whatsapp,
      lineOfBusiness: event.target.line_of_business.value,
    };
    localStorage.setItem("signInData", JSON.stringify(data));
    history.push("step-three");
  }

  return (
    <Step>
      <Title>
        Por favor preencha <br /> os campos abaixo:
      </Title>
      <Form onSubmit={handleSubmit}>
        <InputGroup>
          <label>Nome da sua empresa</label>
          <input
            required
            type="text"
            placeholder="ex: Minha empresa"
            name="business_name"
          />
        </InputGroup>
        <InputGroup>
          <label>Sua cidade</label>
          <input
            required
            type="text"
            placeholder="ex: Porto Alegre"
            name="city"
          />
        </InputGroup>
        <InputGroup>
          <label>Whatsapp do seu Restaurante</label>
          <InputPhone
            required
            type="text"
            placeholder="ex: 11 98987-8998"
            name="whatsapp"
          />
        </InputGroup>
        <InputGroup>
          <label>
            Ramo de atuação <small>(principal)</small>
          </label>
          <select required name="line_of_business">
            <option selected disabled value="">
              -
            </option>
            <option value="Açaiteria">Açaiteria</option>
            <option value="Bebidas">Bebidas</option>
            <option value="Doces e Sobremesas">Doces e Sobremesas</option>
            <option value="Hamburgueria">Hamburgueria</option>
            <option value="Marmitaria">Marmitaria</option>
            <option value="Massas">Massas</option>
            <option value="Pastelaria">Pastelaria</option>
            <option value="Pizzaria">Pizzaria</option>
            <option value="Sushi">Sushi</option>
            <option value="Outro">Outro</option>
          </select>
        </InputGroup>
        {isErrorPhoneFormat && (
          <SignInError style={{ color: "red" }}>
            Por favor preencha o WhatsApp corretamente
          </SignInError>
        )}
        <button type="submit">Continuar</button>
      </Form>
    </Step>
  );
}
